import React from 'react';
import {complete} from 'account-portal-library/lib/googleSignIn';
import {parseCookies, validateSessionToken, isValidGoToURL} from 'account-portal-library/lib/helperFunctions'
import Loader from '../Loader';
import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';
import MissingFields from './MissingFields';
import { getGotoUrlFromCookies } from '../../gotoUrl';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';

const appVars = AppVars.getInstance();
const logger = Logger.getInstance();

const UNKNOWN_ERROR_URL = "/unknownerror";

class FinishGoogle extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            complete: false,
            inputCallback: null,
            registerFields: ["PHONE"]
        }
    }

    getRegisterFields(callbacks){
        const fields = []
        for (const i in callbacks){
            if (callbacks[i].output[0].value === "Email Address") {
                fields.push("EMAIL")
            } else if (callbacks[i].output[0].value === "Mobile Number"){
                fields.push("PHONE")
            }else if (callbacks[i].output[0].value === "First Name"){
                fields.push("FIRST")
            }else if (callbacks[i].output[0].value === "Last Name") {
                fields.push("LAST")
            }
        }
        return fields;
    }

    //Finishes Google sign in flow
    async completeGoogle(){
        logger.log("stage", "Completing Google Sign In");
        const response = await complete(appVars.getBaseUrl(), appVars.getRealm(), appVars.getGoogleSignInTree(), appVars.getDomain(), appVars.getName());
        logger.log("test", "Complete Google Response");
        logger.log("test", response);
        const amAuthResponse = response.response;
        if (response.status > 299){
            navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
        } else {
            if (amAuthResponse.callbacks) {
                if (amAuthResponse.callbacks[0].output[0].name == "prompt"){
                    // We are in a registration event. AM is asking us for a phone number.
                    this.setState({
                        inputCallback: amAuthResponse,
                        registerFields: this.getRegisterFields(amAuthResponse.callbacks)
                    })
                } else {
                    navigateWithAnalytics("/", "default-redirect", "auto");
                }
            } else {
                const validToken = await this.checkToken(response)
                if (validToken) {
                    this.setState({complete: true})
                } else {
                    navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
                }
            }
        }
    }

    async checkToken(loginResponse){
        try {
            const tokenId = loginResponse.response.tokenId
            if (tokenId != null){
                logger.log("test", tokenId)
                const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                logger.log("test", validateResponse)
                return validateResponse.response.valid;
            } else{
                return false
            }
        }
        catch{
            return false
        }
        
    }

    render(){
        //Redirects to default page if page is not requested by valid referrer
        if((document.referrer.includes("youtube") || document.referrer.includes("google") || document.referrer.includes("toyota") ) === false){
            navigateWithAnalytics(appVars.getDefaultHomePage(), "default-redirect", "auto");
            return ""
        } else {
            //If user is already authenticated
            if(this.state.complete){
                const gotoUrl = getGotoUrlFromCookies(['T', 'S']);
                navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
                return "";
            }
            else if (this.state.inputCallback) {
                // We're in a registration event
                return (
                    <MissingFields style = {sessionStorage.AP_STYLE} inputCallback={this.state.inputCallback} registerFields={this.state.registerFields} provider='google'/> 
                )
            }
            else {
                this.completeGoogle();
                return(
                    <Loader />
                )
            }
        }
    
    }
}

export default FinishGoogle;